export { default as GET_DIAMOND_BY_ID } from './getDiamondById.graphql';
export { default as GET_DIAMONDS } from './getDiamonds.graphql';
export { default as GET_HELLO } from './getHello.graphql';
export { default as GET_SHOPIFY_RING_BY_ID } from './getShopifyRingById.graphql';
export { default as GET_SHOPIFY_RINGS } from './getShopifyRings.graphql';
